// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-justify-start[data-v-069c5822]{display:flex;justify-content:start;column-gap:8px}.point-input[data-v-069c5822]{width:100px;font-size:16px}.point-label[data-v-069c5822]{display:flex;align-items:center;font-size:16px}.point-button[data-v-069c5822]{height:100%;width:56px}.point-button-label[data-v-069c5822]{color:#fff;font-size:12px}.warning[data-v-069c5822]{color:#ff7272}", ""]);
// Exports
module.exports = exports;
